import React from "react";
import { FormElement } from "@emisgroup/ui-form";

interface CustomFormElementProps {
  /**
     * Sets the id for the aria-describedby field (only when fieldset is true)
     */
  ariaDescribedBy?: string;
  /**
   * The error text to show
   */
  errorText?: string;
  /**
   * The ID of a single field
   */
  fieldId?: string;
  /**
   * Sets the element to be a fieldset (e.g. for checkboxes or radio buttons)
   */
  fieldset?: boolean;
  /**
   * The form label/legend
   */
  labelText?: string;
  /**
   * Sets the field to mandatory
   */
  mandatory?: boolean;
  /**
   * Form element childrens
   */
  children?: React.ReactNode;
  /**
   * Custom style for the current form element
   */
  className?: string;
  /**
   * Data testid
   */
  id?: string;
}

/**
 * Responsible for rendering the form element
 * @returns form elements
 */
export const UIFormElement: React.FC<CustomFormElementProps> = (props: CustomFormElementProps) => {
  const { children } = props;
  return (
    <FormElement
      {...props}
    >
      {children}
    </FormElement>
  );
};
